import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
    isLoggedIn: boolean;
    tester: number; // Define `tester` as number, with no null since you use 0 as default.
}
const initialState: UserState = {
    isLoggedIn: false,
    tester: 0, // Default value for tester
};
const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setLogin: (state, action: PayloadAction<boolean>) => {
            state.isLoggedIn = action.payload;
        },
        setTester: (state, action: PayloadAction<number>) => {
            state.tester = action.payload; // Update `tester` with the value from the action
        },
    },
});

export const { setLogin, setTester } = userSlice.actions;

export default userSlice.reducer;
